import script from "./ChangeMaxActiveBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeMaxActiveBookings.vue?vue&type=script&setup=true&lang=js"

import "./ChangeMaxActiveBookings.vue?vue&type=style&index=0&id=545b80ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545b80ff"]])

export default __exports__